import { Checkbox } from "@mui/material";
import { ArrowRight, ChevronLeft, Minus, Plus, X } from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import {
  addCompanySearchKeywords,
  removeCompanySearchKeywords,
  saveFiltersState,
  updateCompanySearchOptions,
} from "@redux/slices/filter";
import { useEffect, useState } from "react";
import {useRecoilState } from "recoil";
import { FilterAtom } from "@/App";


interface Props {
  handleClose: () => void;
}

const CompanySearch: React.FC<Props> = ({ handleClose }) => {
  const [searchKeyword, setSearchKeyword] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialSearchOptions = useSelector(
    (state: RootState) =>
      state.filter?.companyFilters?.companySearch?.searchOptions || {
        companyName: false,
        companyDescription: false,
        domainName: false,
      }
  );

  const searchKeywords = useSelector(
    (state: RootState) =>
      state.filter?.companyFilters?.companySearch?.searchKeywords || []
  );

  const data = useSelector((state: RootState) => state.filter);

  const [searchOptions, setSearchOptions] = useState(initialSearchOptions);

  console.log(searchKeywords);

  const handleKeywordAdd = (keyword: string) => {
    console.log(keyword);
    if (!searchKeywords?.includes(keyword)) {
      dispatch(addCompanySearchKeywords(keyword));
      setSearchKeyword("");
    }
  };

  const handleKeywordRemove = (keyword: string) => {

    console.log("I am in removal")
    console.log(keyword);
    if (searchKeywords?.includes(keyword)) {
      dispatch(removeCompanySearchKeywords(keyword));
    }
  };

  useEffect(() => {
    console.log(searchOptions, initialSearchOptions);
  }, [initialSearchOptions]);

  const handleCheckboxChange = (option: keyof typeof searchOptions) => {
    const updatedOptions = {
      ...searchOptions,
      [option]: !searchOptions[option],
    };
    setSearchOptions(updatedOptions);
    dispatch(updateCompanySearchOptions(updatedOptions));
  };

  const handleClick = (id: string) => {
    console.log("now clicked is " + id);
    // setClickedIds((prevStrings) => [...prevStrings, id]);
    setFilter((prevFilters: string[]) => [...prevFilters, id]); // Append to the atom
    console.log("I am here now");
  };

  



  const [filter, setFilter] = useRecoilState(FilterAtom);

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Company Search
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <div className="flex gap-4">
          <div className="w-2/3">
            <div className="relative mb-8">
              <input
                className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm  transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                id="username"
                type="text"
                placeholder="Search"
                value={(searchKeyword)}
                onChange={(e) => setSearchKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleKeywordAdd(searchKeyword); // Call your function when Enter is pressed
                    setSearchKeyword('');
                   
                  }
                }}
              />

              <div className="absolute left-0 inset-y-0 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#71717A"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <div className="absolute right-[10px] inset-y-0 flex items-center">
                {/* <Minus className="cursor-pointer me-4" /> */}
                <Plus
                  className="cursor-pointer"
                  onClick={() => handleKeywordAdd(searchKeyword)}
                 
                />
              </div>
            </div>
            <div className="flex items-center gap-4 flex-wrap  overflow-y-scroll h-60">
              {searchKeywords?.map((val: string, index: number) => {
                return (
                  <div className="bg-white p-8 rounded-lg flex justify-between border-b w-1/2 px-4 py-3 mb-2">
                    <p>{val}</p>
                    <X
                      onClick={() => handleKeywordRemove(val)}
                      className="cursor-pointer"
                      size={20}
                    />
                    
                  </div>
                );
              })}
            </div>
          </div>
          <div className="bg-white w-1/3 rounded-lg px-6 py-4">
            <h4 className="text-lg font-bold flex items-center mb-4">
              Search Options
            </h4>
            <div
              className={` flex items-center text-sm justify-between font-medium cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-0`}
              onClick={() => handleCheckboxChange("companyName")}
            >
              <h6 className="ms-1">In Company Name</h6>
              <Checkbox sx={{
    color: '#1CB5AF', // Unchecked color
    '&.Mui-checked': {
      color: '#1CB5AF', // Checked color
    },
  }} checked={searchOptions.companyName} />
            </div>
            <div
              className={`flex items-center text-sm justify-between font-medium pt-2 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-0`}
              onClick={() => handleCheckboxChange("companyDescription")}
            >
              <h6 className="ms-1">In Company Description</h6>
              <Checkbox sx={{
    color: '', // Unchecked color
    '&.Mui-checked': {
      color: '#1CB5AF', // Checked color
    },
  }}
  
  checked={searchOptions.companyDescription} />
            </div>
            <div
              className={`flex items-center text-sm justify-between font-medium pt-2 cursor-pointer text-[#71717A]`}
              onClick={() => handleCheckboxChange("domainName")}
            >
              <h6 className="ms-1">In Domain Name</h6>
              <Checkbox sx={{
    color: '#1CB5AF', // Unchecked color
    '&.Mui-checked': {
      color: '#1CB5AF', // Checked color
    },
  }} checked={searchOptions.domainName} />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-5 ">
        <Button 
  onClick={() => {
    handleClick("Company Search"); // Replace someValue with the actual value you want to pass
    navigate(-1); // Navigate back
  }}         className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default CompanySearch;
